<template>
    <div id="contact">
        <div class="container pt-5">
            <div class="row">
                <div class="col-12 col-lg-10 mx-auto">
                    <div class="card bg-dark text-light rounded shadow">
                        <div class="card-body">
                            <div class="row pb-3">
                                <div class="col-12">
                                    <div
                                        class="head text-center text-white py-2 rounded bg-danger"
                                        style="margin-top: -40px; box-shadow: 4px 4px 14px 0px rgba(0,0,0,1);"
                                    >
                                        <p class="h3">Get In Touch</p>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="row row-cols-1 row-cols-sm-2 row-cols-md-3 text-center contact-info"
                            >
                                <div class="col">
                                    <div
                                        class="card shadow bg-light text-dark contact-card d-flex align-items-center m-2 pt-3"
                                    >
                                        <i
                                            class="card-icon far fa-envelope mail"
                                        ></i>
                                        <p>{{ email }}</p>
                                    </div>
                                </div>
                                <div class="col">
                                    <div
                                        class="card shadow bg-light text-dark contact-card d-flex align-items-center m-2 pt-3"
                                    >
                                        <i class="card-icon fas fa-phone"></i>
                                        <p>{{ phone }}</p>
                                    </div>
                                </div>
                                <div class="col">
                                    <div
                                        class="card shadow bg-light text-dark contact-card d-flex align-items-center m-2 pt-3"
                                    >
                                        <i
                                            class="card-icon fas fa-map-marker-alt"
                                        ></i>
                                        <p>{{ location }}</p>
                                    </div>
                                </div>
                            </div>

                            <hr class="bg-white" />

                            <form
                                class="form contact-form"
                                @submit.prevent="sendEmail"
                                id="myForm"
                            >
                                <div class="form-row my-4">
                                    <div class="col-lg-6 my-2">
                                        <input
                                            type="text"
                                            class="form-control bg-light success contact-form-text"
                                            name="name"
                                            v-model="form_name"
                                            placeholder="Full Name"
                                            required
                                        />
                                    </div>
                                    <div class="col-lg-6 my-2">
                                        <input
                                            type="email"
                                            class="form-control bg-light error contact-form-text"
                                            name="email"
                                            v-model="form_email"
                                            placeholder="Your Email"
                                            required
                                        />
                                    </div>
                                </div>
                                <div class="form-row my-4">
                                    <div class="col-lg-12">
                                        <input
                                            type="text"
                                            class="form-control bg-white contact-form-text"
                                            name="message"
                                            v-model="form_msg"
                                            placeholder="Your Message"
                                            required
                                        />
                                    </div>
                                </div>
                                <div class="form-row">
                                    <input
                                        class="btn btn-lg btn-outline-danger mx-auto submitbtn"
                                        type="submit"
                                        value="Submit"
                                    />
                                </div>
                            </form>
                        </div>
                        <!-- <div class="container" v-if="form_submitted">
                            <p class="h3" v-if="count > 1">
                                Email has been submitted ( {{ count }} )
                            </p>
                            <p class="h3" v-else>Email has not been submitted!</p>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>

        <div id="map" ref="map"></div>

        <p class="h5 text-dark bg-light m-0 p-3">
            <scrollactive
                :offset="80"
                :duration="800"
                bezier-easing-value=".5,0,.35,1"
            >
                &copy;
                <a class="link text-dark scrollactive-item" href="#home"> Wong Lab </a>
                2021
            </scrollactive>
        </p>
    </div>
</template>


<script>
import emailjs from "emailjs-com";
export default {
    name: "Contact",
    data() {
        return {
            email: "ajwong@stanford.edu",
            phone: "(650)-796-4063",
            location: "1050 Arastradero Rd, Palo Alto",
            count: 0,
            form_name: null,
            form_email: null,
            form_phone: null,
            form_msg: null,
            form_valid: false,
            form_submitted: false,

            map: null,
            marker: null,
            mapOptions: {
                zoom: 16,

                center: new window.google.maps.LatLng(37.395191, -122.145601),

                // disableDefaultUI: true,
                scrollwheel: true,
                draggable: true,

                styles: [
                    {
                        featureType: "all",
                        elementType: "labels",
                        stylers: [
                            {
                                visibility: "on",
                            },
                        ],
                    },
                    {
                        featureType: "all",
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                saturation: 36,
                            },
                            {
                                color: "#000000",
                            },
                            {
                                lightness: 40,
                            },
                        ],
                    },
                    {
                        featureType: "all",
                        elementType: "labels.text.stroke",
                        stylers: [
                            {
                                visibility: "on",
                            },
                            {
                                color: "#000000",
                            },
                            {
                                lightness: 16,
                            },
                        ],
                    },
                    {
                        featureType: "all",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "administrative",
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#000000",
                            },
                            {
                                lightness: 20,
                            },
                        ],
                    },
                    {
                        featureType: "administrative",
                        elementType: "geometry.stroke",
                        stylers: [
                            {
                                color: "#000000",
                            },
                            {
                                lightness: 17,
                            },
                            {
                                weight: 1.2,
                            },
                        ],
                    },
                    {
                        featureType: "administrative.locality",
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#c4c4c4",
                            },
                        ],
                    },
                    {
                        featureType: "administrative.neighborhood",
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#707070",
                            },
                        ],
                    },
                    {
                        featureType: "landscape",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#000000",
                            },
                            {
                                lightness: 20,
                            },
                        ],
                    },
                    {
                        featureType: "poi",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#000000",
                            },
                            {
                                lightness: 21,
                            },
                            {
                                visibility: "on",
                            },
                        ],
                    },
                    {
                        featureType: "poi.business",
                        elementType: "geometry",
                        stylers: [
                            {
                                visibility: "on",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#be2026",
                            },
                            {
                                lightness: "0",
                            },
                            {
                                visibility: "on",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry.stroke",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "labels.text.stroke",
                        stylers: [
                            {
                                visibility: "off",
                            },
                            {
                                hue: "#ff000a",
                            },
                        ],
                    },
                    {
                        featureType: "road.arterial",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#000000",
                            },
                            {
                                lightness: 18,
                            },
                        ],
                    },
                    {
                        featureType: "road.arterial",
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#575757",
                            },
                        ],
                    },
                    {
                        featureType: "road.arterial",
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    },
                    {
                        featureType: "road.arterial",
                        elementType: "labels.text.stroke",
                        stylers: [
                            {
                                color: "#2c2c2c",
                            },
                        ],
                    },
                    {
                        featureType: "road.local",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#000000",
                            },
                            {
                                lightness: 16,
                            },
                        ],
                    },
                    {
                        featureType: "road.local",
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#999999",
                            },
                        ],
                    },
                    {
                        featureType: "road.local",
                        elementType: "labels.text.stroke",
                        stylers: [
                            {
                                saturation: "-52",
                            },
                        ],
                    },
                    {
                        featureType: "transit",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#000000",
                            },
                            {
                                lightness: 19,
                            },
                        ],
                    },
                    {
                        featureType: "water",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#000000",
                            },
                            {
                                lightness: 17,
                            },
                        ],
                    },
                    // {
                    //     featureType: "water",
                    //     elementType: "geometry",
                    //     stylers: [
                    //         {
                    //             color: "#000000",
                    //         },
                    //         {
                    //             lightness: 10,
                    //         },
                    //     ],
                    // },
                    // {
                    //     featureType: "landscape",
                    //     elementType: "geometry",
                    //     stylers: [
                    //         {
                    //             color: "#000000",
                    //         },
                    //         {
                    //             lightness: 20,
                    //         },
                    //     ],
                    // },
                    // {
                    //     featureType: "road.highway",
                    //     elementType: "geometry.fill",
                    //     stylers: [
                    //         {
                    //             color: "#000000",
                    //         },
                    //         {
                    //             lightness: 15,
                    //         },
                    //     ],
                    // },
                    // {
                    //     featureType: "road.highway",
                    //     elementType: "geometry.stroke",
                    //     stylers: [
                    //         {
                    //             color: "#000000",
                    //         },
                    //         {
                    //             lightness: 29,
                    //         },
                    //         {
                    //             weight: 0.2,
                    //         },
                    //     ],
                    // },
                    // {
                    //     featureType: "road.arterial",
                    //     elementType: "geometry",
                    //     stylers: [
                    //         {
                    //             color: "#000000",
                    //         },
                    //         {
                    //             lightness: 18,
                    //         },
                    //     ],
                    // },
                    // {
                    //     featureType: "road.local",
                    //     elementType: "geometry",
                    //     stylers: [
                    //         {
                    //             color: "#000000",
                    //         },
                    //         {
                    //             lightness: 16,
                    //         },
                    //     ],
                    // },
                    // {
                    //     featureType: "poi",
                    //     elementType: "geometry",
                    //     stylers: [
                    //         {
                    //             color: "#000000",
                    //         },
                    //         {
                    //             lightness: 21,
                    //         },
                    //     ],
                    // },
                    // {
                    //     elementType: "labels.text.stroke",
                    //     stylers: [
                    //         {
                    //             visibility: "on",
                    //         },
                    //         {
                    //             color: "#000000",
                    //         },
                    //         {
                    //             lightness: 16,
                    //         },
                    //     ],
                    // },
                    // {
                    //     elementType: "labels.text.fill",
                    //     stylers: [
                    //         {
                    //             saturation: 36,
                    //         },
                    //         {
                    //             color: "#000000",
                    //         },
                    //         {
                    //             lightness: 40,
                    //         },
                    //     ],
                    // },
                    // {
                    //     elementType: "labels.icon",
                    //     stylers: [
                    //         {
                    //             visibility: "off",
                    //         },
                    //     ],
                    // },
                    // {
                    //     featureType: "transit",
                    //     elementType: "geometry",
                    //     stylers: [
                    //         {
                    //             color: "#000000",
                    //         },
                    //         {
                    //             lightness: 19,
                    //         },
                    //     ],
                    // },
                    // {
                    //     featureType: "administrative",
                    //     elementType: "geometry.fill",
                    //     stylers: [
                    //         {
                    //             color: "#000000",
                    //         },
                    //         {
                    //             lightness: 20,
                    //         },
                    //     ],
                    // },
                    // {
                    //     featureType: "administrative",
                    //     elementType: "geometry.stroke",
                    //     stylers: [
                    //         {
                    //             color: "#000000",
                    //         },
                    //         {
                    //             lightness: 17,
                    //         },
                    //         {
                    //             weight: 1.2,
                    //         },
                    //     ],
                    // },
                ],
            },
        };
    },

    methods: {
        setMap() {
            this.map = new window.google.maps.Map(
                document.getElementById("map"),
                this.mapOptions
            );

            new window.google.maps.Marker({
                position: { lat: 37.395191, lng: -122.1456019 },
                title: "Marker Title",
                map: this.map,
            });
        },
        sendEmail(e) {
            // this.form_submitted = true;

            // let inputs = document.getElementsByClassName("contact-form-text");
            // let errorID = [];

            // if (!this.form_name || this.form_name == "") {
            //     errorID.push(0);
            // }
            // if (!this.form_email || this.form_email == "") {
            //     errorID.push(1);
            // }
            // if (!this.form_msg || this.form_msg == "") {
            //     errorID.push(3);
            // }

            // for (let i = 0; i < errorID.length; i++) {
            //     inputs[errorID[i]].classList.toggle("error");
            // }

            // if (errorID.length > 0) return;

            // document.getElementById("myForm").reset();
            // this.count = this.count + 1;
            const submitBtn = document.querySelector(".submitbtn");
            submitBtn.value = "Sending...";
            console.log(this.form_name, this.form_email, this.form_msg);
            // document.querySelector(".success").style.opacity = 1;

            emailjs
                .sendForm(
                    "default_service",
                    "contact",
                    e.target,
                    "user_k5iHEP67Yl39nBLXL2N5G"
                )
                .then(
                    (result) => {
                        submitBtn.value = "Submit";
                        console.log("SUCCESS!", result.status, result.text);
                    },
                    (error) => {
                        console.log("FAILED...", error);
                    }
                );

            // console.log(e, emailjs);
        },
    },

    mounted() {
        if (this.map == null) {
            this.setMap();
        }
    },
};
</script>

<style scoped>
#contact {
    background: #767676;
    width: 100%;
}

.contact-card {
    height: 150px;
    display: flex;

    justify-content: center;
    align-items: center;
    color: white;
    word-wrap: break-word;
    border-radius: 10px;
}

.contact-info {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.card-icon {
    font-size: 28px;
    background: #ff6348;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px !important;
    border-radius: 50%;
    transition: 0.3s linear;
    margin: 0 auto;
}

.contact-card p {
    /* letter-spacing: 2px; */
    opacity: 0;
    min-height: 0;
    transition: 0.3s linear;
    max-height: 0;
    font-size: 18px;
    /* font-weight: light; */
}

.contact-card:hover .card-icon {
    background: none;
    color: #ff6348;
    transform: scale(1.5);
}

.contact-card:hover p {
    opacity: 1;
    max-height: 50px;
}

.contact {
    text-decoration: none;
    color: white;
    text-transform: uppercase;
    font-size: 32px;
}

.contact:hover {
    font-weight: bold;
    text-decoration: underline;
}

/* .form-control.success {
    border-color: #2ecc71;
}
.form-control.error {
    border-color: #e74c3c;
} */

.form-control:focus {
    -webkit-box-shadow: none;
    box-shadow: none;
}

/* 
.form-control::-webkit-input-placeholder {
  color: #bec6cc;
}
.form-control:-moz-placeholder {
  color: #bec6cc;
}
.form-control::-moz-placeholder {
  color: #bec6cc;
}
.form-control::placeholder {
  color: #bec6cc;
}
.form-control:-ms-input-placeholder {
  color: #bec6cc;
} */

#map {
    height: 400px;
    margin: 40px;
    border-radius: 10px;
}
</style>
